enum Step {
  infoForm,
  addressForm,
  cardForm,
  bankTransferForm,
  subscriptionForm,
}

export default Step
